import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <>
      <footer className="site-footer">
        <div className="shell footer-grid">
          <div>
            <p className="brand-lockup">
              <img className="brand-mark" src="/assets/brand/logo-mark.png" alt="" width={24} height={24} />
              <span className="brand">念影</span>
            </p>
            <p className="mt-3 type-body-md text-ink-secondary">
              以温柔与敬意，留下一幅庄重的肖像。
            </p>
          </div>
          <div>
            <h3>条款与说明</h3>
            <ul>
              <li><Link to="/legal/terms">服务条款</Link></li>
              <li><Link to="/legal/privacy">隐私政策</Link></li>
              <li><Link to="/legal/authorization">肖像授权说明</Link></li>
              <li><Link to="/legal/ai-notice">AI 生成内容标识</Link></li>
            </ul>
          </div>
          <div>
            <h3>浏览</h3>
            <ul>
              <li><Link to="/">首页</Link></li>
              <li><Link to="/order/new">开始制作</Link></li>
              <li><Link to="/account/orders">我的订单</Link></li>
            </ul>
          </div>
        </div>
        <p className="shell footer-admin">
          <Link to="/admin/login">管理入口</Link>
        </p>
      </footer>
      <div className="disclaimer-strip">
        <div className="shell">
          <p className="type-label-sm text-ink-muted">
            验证期服务。成品为 AI 辅助生成，请与原图核对后确认采用。支付通过闲鱼人工核销完成。
          </p>
        </div>
      </div>
    </>
  );
}
